import { ptBR } from '@mui/x-data-grid/locales';
import type { GridLocaleText } from '@mui/x-data-grid';

/** Textos do DataGrid em português (pt-BR). */
export const dataGridLocaleText: Partial<GridLocaleText> =
  ptBR.components.MuiDataGrid.defaultProps.localeText;
